export enum ProjectStatus {
  ACTIVE,
  INACTIVE,
  EXPIRATED
}
